import {Tabs} from './components/Tabs.js';
import {CookiesPanel} from './components/CookiesPanel.js';
import MainMenu from './components/MainMenu.js';
import {modal} from './utils/modal.js';
import anim from './utils/anim.js';
import menuBtn from './utils/btnsMenu.js';
import {Accordion} from './components/Accordion.js';
import calculator from './utils/calculator.js';
import {DropPanel} from './components/DropPanel.js';

document.addEventListener('DOMContentLoaded', () => {

    anim();
    modal();
    const tabs = new Tabs();
    tabs.init();
    calculator();
    menuBtn();
    const dropdown = new DropPanel();
    dropdown.init();
    new MainMenu({
        container: '[data-main-menu="wrapper"]',
        trigger: '[data-main-menu="trigger"]',
        menu: '[data-main-menu="menu"]',
        overlay: '[data-main-menu="overlay"]',
        openClass: 'is-open',
    });

    const cookiesPanel = new CookiesPanel({
        cookieName: 'cookiesAccepted',
        wrapper: document.querySelector('[data-cookies-panel="wrapper"]'),
        button: document.querySelector('[data-cookies-panel="button"]'),
    });
    cookiesPanel.init();

    const accordion = new Accordion({
        wrapperAttr: 'wrapper',
        triggerAttr: 'trigger',
        activeClass: 'is-active',
        single: false,
    });

    accordion.init();
});


